// extracted by mini-css-extract-plugin
export var container = "_cp-0";
export var containerTopRight = "_cp-1";